import { User } from '@/types/admin';
import EntityUser from './EntityUser';
import { useAdminApi } from '@/hooks/useAdminApi';
import { AdministrationApiContextType } from '@/types/util.types';

type EntityUsersProps = {
  users: User[];
};
function EntityUsers(entityUsers: EntityUsersProps) {
  const { removeUserFromEntity } = useAdminApi() as AdministrationApiContextType;
  return (
    <div className='flex flex-col px-8 pb-4 border-2 rounded-md'>
      <h4>Users</h4>
      <div className='relative overflow-x-auto shadow-md sm:rounded-lg'>
        <table className='w-full text-sm text-left rtl:text-right text-gray-500 '>
          <thead className='text-xs text-gray-700 uppercase bg-gray-50  '>
            <tr>
              <th scope='col' className='px-6 py-3'>
                Email
              </th>
              <th scope='col' className='px-6 py-3'>
                Roles
              </th>
              <th scope='col' className='px-6 py-3'>
                Invited By
              </th>
              <th scope='col' className='px-6 py-3'>
                Invited On
              </th>

              <th scope='col' className='px-6 py-3'>
                Accepted
              </th>
              <th scope='col' className='px-6 py-3'>
                Accepted On
              </th>
              <th scope='col' className='px-6 py-3'></th>
            </tr>
          </thead>
          <tbody>
            {entityUsers.users.map((user) => (
              <EntityUser key={user.email} user={user} removeUser={removeUserFromEntity}></EntityUser>
            ))}
          </tbody>
        </table>
      </div>
      {/* <div className='lg:w-2/3 sm:w-full md:w-full mt-8'>
        <InvitationForm
          allowedRoles={allowedRoles}
          safelistedDomains={safelistedDomains}
          isEntityInvite={true}
          inviteUser={(email: string, firstName: string, lastName: string, roles?: string[]) => {
            if (roles) {
              inviteUserToEntity(email, firstName, lastName, roles);
            }
          }}
        />
      </div> */}
    </div>
  );
}

export default EntityUsers;
